import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

import { CloseCircleOutlined, GlobalOutlined, ExclamationCircleFilled } from "@/utils/antdIcon";
import { LoginFormContext } from "./utils";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import {
  AuthDataRes,
  CreateTeamAndEmployee,
  TeamUserInfo,
  ValidateAccountRes,
  ValidateAccountReq,
  BizTypeEnum,
  UserType
} from "@/types/LoginPage";
import LoginForm from "./forms/LoginForm";
import VerifyCodeForm from "./forms/VerifyCodeForm";
import ActiveUserForm from "./forms/ActiveUserForm";
import VerifyPwdForm from "./forms/VerifyPwdForm";
import ResetPwdForm from "./forms/ResetPwdForm";
import NameInputForm from "./forms/NameInputForm";
import JoinMeForm from "./forms/JoinMe";
import SelectAccountTypeForm from "./forms/SelectAccountTypeForm";
import SelectPublicAccountForm from "./forms/SelectPublicAccountForm";
import logger from "@/utils/logger";
import { useTranslation } from "react-i18next";
// import "./index.less";
import { message, Modal, Popover, Tooltip } from "antd";
import cookies from "js-cookie";
import BindMobileModal from "@/components/Modals/BindMobileModal";
import { crossAppSwitch } from "@/utils/tools";
import { FocusSDK, forceLogin, isFocusEnv } from "@/utils";
import sentryManual from "@/utils/sentryManual";
import { PUBLIC_LOGIN_ERROR_CODE } from "@/server/constants";
import qrcodeImg from "@/assets/img/login/qrcode.png";
import mobileImg from "@/assets/img/login/mobile.png";
import Bus from "@/utils/bus";
import Loading from "../Loading";
import styles from "./index.module.less";
import "./indexNew.less";
import loginBg3 from "@/assets/img/login/loginBg3.png";

const { REACT_APP_DEFAULT_RESEND_PERIOD: DEFAULT_RESEND_PERIOD = "60" } = process.env;

const log = logger.getLogger("LoginPage");

function LoginComp() {
  const { t } = useTranslation("common");
  // eslint-disable-next-line no-debugger
  // debugger;
  const { onGlobalError, service, focusSDK, authInfo, commonConfig, appRuntimeEnv } = useContext<
    GlobalContextConfig
  >(GlobalContext);
  console.log(authInfo, "authInfo");
  const [resendLastTs, setResendLastTs] = useState(0);
  const [loginType, setLoginType] = useState("MOBILE");
  const [loginMode, setLoginMode] = useState("");
  const [teamId, setTeamId] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [currentTeam, setCurrentTeam] = useState<any>(null);
  const [account, setAccount] = useState("");
  const [userName, setUserName] = useState("");
  const [autoLogin, setAutoLogin] = useState(false);
  const [routePath, setRoutePath] = useState("");
  // const [routePath, setRoutePath] = useState("stepSelAccount");
  const [authCode, setAuthCode] = useState("");
  const [userData, setUserData] = useState<AuthDataRes | null>(authInfo);
  const [accountInfo, setAccountInfo] = useState<ValidateAccountRes | null>(null);
  const [loginName, setLoginName] = useState("");
  const [bizType, setBizType] = useState(BizTypeEnum.APP_LOGIN);
  const [bindMobileVisible, setBindMobileVisible] = useState(false);
  const [ndaModalVisible, setNDAModalVisible] = useState(false);
  const [scanCode, setScanCode] = useState(true);
  const [loginAccountMethod, setLoginAccountMethod] = useState("");
  const [userTicketData, setUserTicketData] = useState<AuthDataRes | null>(null);
  const isCheckedRef = useRef(false);
  const loginWebview = React.useRef<HTMLWebViewElement | null>(null);

  // 三方登录点
  const appThridLogin = useMemo(() => {
    try {
      const appThridLogin = JSON.parse(commonConfig?.appThridLogin);
      return appThridLogin;
    } catch (e) {
      return null;
    }
  }, [commonConfig]);

  const isThirdLogin = useMemo(() => {
    return isFocusEnv() && !!appThridLogin && appThridLogin?.loginType === 1;
  }, [appThridLogin]);

  const thirdLoginUrl = useMemo(() => {
    if (!isThirdLogin) {
      return "";
    }
    try {
      return appThridLogin?.loginUrl || appThridLogin?.egovLoginUrl;
    } catch (e) {
      return "";
    }
  }, [isThirdLogin, appThridLogin]);

  const preloadjs = useMemo(() => {
    if (!isFocusEnv()) {
      return "";
    }
    const ps = FocusSDK.getAppPreloadJSPath("1.0.0");
    return ps;
  }, []);

  const handleClientMessages = ({ cid, type, data }: any) => {
    const wv = loginWebview.current as any;
    switch (type) {
      case "token-reply":
        service?.focusService
          ?.verifyThirdTokenLogin?.({
            appId: appRuntimeEnv?.runtimeConfig?.key || "",
            token: data?.token
          })
          .then((res: any) => {
            if (res) {
              // token置换authdata
              doHandleLoginFn(res as AuthDataRes);
              if (res?.mobile) {
                setMobile(res?.mobile);
              }
            }
          });
    }
  };

  const handleIPCMessage = (event: any) => {
    const { args, channel } = event;
    const [methodContent] = args || []; // 调用方法内容 方法名 方法参数
    switch (channel) {
      case "clientMessage":
        if (methodContent) {
          handleClientMessages(methodContent);
        }
        break;
      default:
        if (channel.startsWith("wv:")) {
          Bus.emit(channel, methodContent);
        }
        break;
    }
  };

  const bindEvent = useCallback(() => {
    const wv = loginWebview.current;
    if (!wv) {
      return () => {};
    }
    wv.addEventListener("ipc-message", handleIPCMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateCb = useCallback(
    (path: string) => {
      if (path === "step1") {
        // 三方登录
        if (isThirdLogin) {
          setRoutePath("thirdLogin");
          return;
        }
      }
      setRoutePath(path);
    },
    [isThirdLogin]
  );

  const onMobileChange = useCallback((f: string) => {
    if (f && f.length > 11) {
      return;
    }
    setMobile(f);
  }, []);

  const onEmailChange = useCallback((f: string) => {
    setEmail(f);
  }, []);

  const onAccountChange = useCallback((f: string) => {
    setAccount(f);
  }, []);

  const onLoginTypeChange = useCallback((f: string) => {
    setLoginType(f);
  }, []);

  const onTeamIdChange = useCallback((f: string) => {
    setTeamId(f);
  }, []);

  const onAutoLoginChange = useCallback((f: boolean) => {
    setAutoLogin(f);
  }, []);

  const onUserNameChange = useCallback((f: string) => {
    setUserName(f);
  }, []);
  const onLoginModeChange = useCallback((f: string) => {
    setLoginMode(f);
  }, []);

  useEffect(() => {
    focusSDK.printLog("useEffect-autoLogin", autoLogin);
    isCheckedRef.current = autoLogin;
  }, [autoLogin, focusSDK]);
  useEffect(() => {
    if (localStorage.getItem("nda_readed") !== "true") {
      setNDAModalVisible(true);
    }
  }, [setNDAModalVisible]);

  const onSelectTeam = useCallback(
    (teamId: string, data?: any) => {
      focusSDK.printLog("onSelectTeam", isCheckedRef.current);
      if (!data && !userData) {
        onGlobalError(new Error("Can not get user data when login."));
        return;
      }
      focusSDK.login(
        data || userData,
        teamId,
        () => {
          log.debug("focusSDK.login callback");
          focusSDK.emit("loginSuccess");
        },
        isCheckedRef.current
      );
    },
    [focusSDK, onGlobalError, userData]
  );

  const enterApplication = useCallback(
    (teamInfo: CreateTeamAndEmployee | TeamUserInfo | null) => {
      if (!teamInfo) {
        onGlobalError(new Error("Can not get team data when login."));
        return;
      }
      if (!userData) {
        onGlobalError(new Error("Can not get user data when login."));
        return;
      }
      focusSDK.login(
        {
          ...userData,
          selectedTeamId: teamInfo.teamId,
          teamUserInfo: teamInfo,
          teamUserInfoList: [teamInfo]
        },
        teamInfo.teamId,
        () => {
          focusSDK.emit("loginSuccess");
        },
        autoLogin
      );
    },
    [focusSDK, onGlobalError, userData, autoLogin]
  );

  const handleUserData = useCallback(
    async (data: AuthDataRes) => {
      setUserData(data);
      service.focusService.setToken(data.accessToken);
    },
    [service.focusService, setUserData]
  );
  const navigateActive = (team: any, data?: any) => {
    service.authService
      .unEnableApprStatus({
        "x-token": data?.accessToken || userData?.accessToken,
        "x-team-id": team.teamId
      })
      .then(() => {
        setCurrentTeam(team);
        setRoutePath("active");
      })
      .catch((e) => {
        console.error(e.toString());
      });
  };
  const selectedTeam = useCallback(
    async (data: AuthDataRes, loginType?: string) => {
      try {
        await handleUserData(data);
        const teamUserInfoList = data.teamUserInfoList || [];
        const selectedTeamId = "";
        logger.log("登录后选择租户", teamUserInfoList, selectedTeamId);
        FocusSDK.printLog("登录后选择租户", teamUserInfoList, selectedTeamId);
        if (teamUserInfoList.length === 1) {
          if (teamUserInfoList[0].emplEnabled !== "DIS_ENABLED") {
            onSelectTeam(teamUserInfoList[0].teamId, data);
          } else if (teamUserInfoList[0].userType === UserType.EXTERNAL) {
            navigateActive(teamUserInfoList[0], data);
          } else {
            message.destroy();
            message.warn("该账号已被冻结，如有疑问请联系所在单位管理员进行核查。");
            if (loginType === "public") {
              // focusSDK.logout();
            } else {
              navigateCb("step1");
            }
          }
        } else if (selectedTeamId && teamUserInfoList.find((el) => el.teamId === selectedTeamId)) {
          onSelectTeam(selectedTeamId, data);
        } else {
          // 创建团队或者选择租户
          const timer = setTimeout(() => {
            setRoutePath("stepNewTeam");
            clearTimeout(timer);
          }, 0);
        }
      } catch (err) {
        console.warn(err);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleUserData, onSelectTeam, navigateCb]
  );

  const selectedAccountMethod = useCallback(async (data: AuthDataRes, tag: string) => {
    setRoutePath("stepSelAccount");
    setLoginAccountMethod(tag);
    setUserTicketData(data);
  }, []);

  const selPublicAccount = useCallback(() => {
    setRoutePath("stepSelPublicAccount");
  }, []);

  const bindEnterpriseMobile = useCallback(async (data: AuthDataRes) => {
    setUserData(data);
    setBindMobileVisible(true);
  }, []);

  const getcurrentLoginType = useCallback(
    (bizType?: BizTypeEnum) => {
      let params: {
        bizType: BizTypeEnum;
        loginName: string;
        loginNameType: string;
        teamId?: string;
        registerFlag?: number;
      } = {
        bizType: bizType || BizTypeEnum.APP_LOGIN,
        loginName: mobile,
        loginNameType: "MOBILE"
      };
      switch (loginType) {
        case "MOBILE":
          params = {
            ...params,
            loginName: mobile,
            loginNameType: "MOBILE",
            registerFlag: crossAppSwitch("selfRegistration") ? 1 : 0
          };
          break;
        case "EMAIL":
          params = {
            ...params,
            loginName: email,
            loginNameType: "EMAIL",
            registerFlag: crossAppSwitch("selfRegistration") ? 1 : 0
          };
          break;
        case "ACCOUNT":
          params = {
            ...params,
            loginName: account,
            loginNameType: "ACCOUNT"
          };
          break;
      }
      if (loginMode === "vip" && teamId) {
        params.teamId = teamId;
      }
      setLoginName(params.loginName);
      return params;
    },
    [loginType, loginMode, mobile, teamId, account, email]
  );

  const sendVerifyCode = useCallback(
    async (params?: ValidateAccountReq, bizType?: BizTypeEnum) => {
      try {
        setBizType(bizType || BizTypeEnum.APP_LOGIN);
        const req = params || getcurrentLoginType(bizType);
        let receive = "";
        if (loginMode === "vip") {
          const res = await service.authService.exclusiveAppLoginSendVerCode(req);
          receive = res.receive;
        } else {
          const res = await service.authService.appSendVerCode(req);
          receive = res.receive;
        }
        if (receive) {
          setMobile(receive);
        }
        setRoutePath("step2");
        setResendLastTs(parseInt(DEFAULT_RESEND_PERIOD, 10));
        message.success(t("login.resendVerifyCodeSuccess"));
        return receive;
      } catch (err) {}
    },
    [setBizType, loginMode, service.authService, getcurrentLoginType, t]
  );

  const onSendCode = useCallback(async () => {
    try {
      const params: ValidateAccountReq = getcurrentLoginType();
      if (loginMode === "vip") {
        const res = await service.authService.exclusiveValidateAccount(params);
        setAccountInfo(res);
        const { hasPassword, isTrustedDevice, hasMobile } = res;
        if (hasMobile) {
          if (hasPassword && isTrustedDevice) {
            setRoutePath("step3");
          } else {
            sendVerifyCode(params);
          }
        } else {
          setRoutePath("step3");
        }
      } else {
        const res = await service.authService.validateAccount(params);
        setAccountInfo(res);
        const { hasPassword, isTrustedDevice } = res;
        if (hasPassword && isTrustedDevice) {
          setRoutePath("step3");
        } else {
          sendVerifyCode(params);
        }
      }
    } catch (error) {
      sentryManual.captureException(error, "login-email");
      focusSDK.printLog("login-email", (error as any)?.stack || (error as any)?.message || error);
      if ((error as any).code !== "10160038") {
        message.error(t("login.resendVerifyCodeError"));
      }
    }
    return false;
  }, [getcurrentLoginType, loginMode, service.authService, sendVerifyCode, t, focusSDK]);

  const onVerifySuccess = useCallback(
    (data: any, loginType?: string) => {
      if (bizType === BizTypeEnum.SET_PASSWORD) {
        setAuthCode(data.authCode);
        setRoutePath("reset");
      } else if (bizType === BizTypeEnum.BIND_MOBILE) {
        setRoutePath("bind");
      } else {
        selectedTeam(data, loginType);
      }
    },
    [bizType, selectedTeam]
  );

  const onPwdSuccess = useCallback(
    (data: any, loginType?: string) => {
      if (loginMode === "vip" && !data.hasBindMobile) {
        bindEnterpriseMobile(data);
      } else {
        selectedTeam(data, loginType);
      }
    },
    [loginMode, bindEnterpriseMobile, selectedTeam]
  );

  const onTicketLoginSuccess = useCallback(
    async (data: any) => {
      const { ticket, userId, usageUserId, loginType, pubTeamId } = data;
      try {
        const content = await service.authService.ticketLoginExchangeToken({
          ticket,
          userId,
          usageUserId
        });
        if (PUBLIC_LOGIN_ERROR_CODE.includes(content?.errorCode)) {
          Modal.confirm({
            title: "公共账号使用提醒",
            icon: <ExclamationCircleFilled style={{ marginRight: "8px", color: "#ED6A0C" }} />,
            content: (
              <span style={{ color: "#666666" }}>{content.errorMsg || "登录失败，请稍后再试"}</span>
            ),
            cancelText: "取消",
            okText: "我知道了"
          });
          return;
        }
        let _info = content;
        if (loginType === "public") {
          const { teamUserInfoList = [] } = content || {};
          const filterTeamList = teamUserInfoList.filter((item) => {
            return item.teamId === pubTeamId;
          });
          _info = filterTeamList.length
            ? {
                ...content,
                teamUserInfoList: filterTeamList
              }
            : content;
        }

        if (loginAccountMethod === "vercode") {
          onVerifySuccess(_info, loginType);
        } else if (loginAccountMethod === "pwd") {
          onPwdSuccess(_info, loginType);
        } else if (
          loginAccountMethod === "qrcode" ||
          loginAccountMethod === "caCert" ||
          loginAccountMethod === "thirdLogin"
        ) {
          selectedTeam(_info, loginType);
        }
      } catch (err) {
        console.warn(err);
      }
    },
    [userTicketData, loginAccountMethod]
  );

  const doHandleLoginFn = useCallback(
    async (res: AuthDataRes) => {
      if (res?.publicAccountList?.length) {
        // 公共账号
        selectedAccountMethod(res, "thirdLogin");
        return;
      }
      await handleUserData(res);
      setUserData(res);
      const teamUserInfoList = res.teamUserInfoList || [];
      const selectedTeamId = cookies.get("focus-team-id");
      if (teamUserInfoList.length === 1) {
        onSelectTeam(teamUserInfoList[0].teamId, res);
      } else if (selectedTeamId && teamUserInfoList.find((el) => el.teamId === selectedTeamId)) {
        onSelectTeam(selectedTeamId, res);
      } else {
        const timer = setTimeout(() => {
          setScanCode(false);
          setRoutePath("stepNewTeam");
          clearTimeout(timer);
        }, 0);
      }
    },
    [handleUserData, onSelectTeam, selectedAccountMethod]
  );

  const fastLoginSelectTeam = useCallback(
    async (data: any) => {
      const res = await service.authService.fastLogin(
        {
          accessToken: data.twoToken.accessToken,
          userId: data.userId
        },
        {
          "x-token": data.twoToken.accessToken
        }
      );
      if (!res) {
        return;
      }
      await doHandleLoginFn(res);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setUserData, service.authService]
  );
  const currentForm = useMemo(() => {
    switch (routePath) {
      case "step1":
        return <LoginForm onSelAccount={selectedAccountMethod} />;
      // return <MobileInputForm onSelAccount={selectedAccountMethod} />;
      case "step2":
        return (
          <VerifyCodeForm
            onSuccess={onVerifySuccess}
            onNewUser={(data) => {
              setAuthCode(data);
              setRoutePath("stepNewUser");
            }}
            onNewTeam={selectedTeam}
            onSelAccount={selectedAccountMethod}
          />
        );
      case "step3":
        return (
          <VerifyPwdForm
            onSuccess={onPwdSuccess}
            onNewUser={(data) => {
              setAuthCode(data);
              setRoutePath("stepNewUser");
            }}
            onNewTeam={selectedTeam}
            onSendVerify={sendVerifyCode}
            onSendResetVerify={() => sendVerifyCode(undefined, BizTypeEnum.SET_PASSWORD)}
            onSelAccount={selectedAccountMethod}
          />
        );
      case "reset":
        return (
          <ResetPwdForm
            authCode={authCode}
            onSuccess={onPwdSuccess}
            onNewUser={(data) => {
              setAuthCode(data);
              setRoutePath("stepNewUser");
            }}
            onNewTeam={selectedTeam}
          />
        );
      case "active":
        return (
          <ActiveUserForm
            onSelectTeam={onSelectTeam}
            userData={userData as AuthDataRes}
            team={currentTeam || {}}
          />
        );
      case "stepNewUser":
        return <NameInputForm authCode={authCode} onCreateUser={selectedTeam} />;
      case "stepNewTeam":
        return <JoinMeForm showActive={navigateActive} onSelectTeam={onSelectTeam} />;
      case "stepSelAccount":
        return (
          <SelectAccountTypeForm
            onPublicAccount={selPublicAccount}
            onPerCodeSuccess={onVerifySuccess}
            onPerPwdSuccess={onPwdSuccess}
            onTicketLoginSuccess={onTicketLoginSuccess}
            userTicketData={userTicketData as AuthDataRes}
          />
        );
      case "stepSelPublicAccount":
        return (
          <SelectPublicAccountForm
            userTicketData={userTicketData as AuthDataRes}
            onTicketLoginSuccess={onTicketLoginSuccess}
          />
        );
      default:
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    authCode,
    sendVerifyCode,
    onSelectTeam,
    routePath,
    selectedTeam,
    onVerifySuccess,
    onPwdSuccess,
    fastLoginSelectTeam,
    scanCode,
    userTicketData,
    onTicketLoginSuccess
  ]);

  useEffect(() => {
    if (commonConfig?.ready) {
      if (isThirdLogin) {
        setRoutePath("thirdLogin");
      } else {
        setRoutePath("step1");
      }
    }
  }, [commonConfig?.ready, isThirdLogin]);
  if (!commonConfig?.ready) {
    return <Loading />;
  }

  if (routePath === "thirdLogin") {
    return (
      <webview
        ref={(ref) => {
          loginWebview.current = ref;
          bindEvent();
        }}
        id="logincontainer"
        preload={preloadjs}
        src={decodeURIComponent(thirdLoginUrl)}
        webpreferences="contextIsolation=no,sandbox=false"
        plugins
        // @ts-ignore
        allowpopups="true"
        style={{ height: "100%", width: "100%" }}
      />
    );
  }
  const arrow = true;
  return (
    <LoginFormContext.Provider
      value={{
        resendLastTs,
        setResendLastTs: (ts: number) => {
          setResendLastTs(ts);
        },
        loginType,
        loginMode,
        teamId,
        mobile,
        email,
        account,
        loginName,
        navigatePath: routePath,
        navigate: navigateCb,
        onLoginTypeChange,
        onTeamIdChange,
        onMobileChange,
        onEmailChange,
        onAccountChange,
        onLoginModeChange,
        userName,
        onUserNameChange,
        autoLogin,
        onAutoLoginChange,
        sendVerifyCode,
        onSendCode,
        enterApplication,
        selectedTeam,
        authInfo: userData as AuthDataRes,
        accountInfo: accountInfo as ValidateAccountRes,
        bizType,
        onLoginError: onGlobalError
      }}
    >
      <div className={styles.loginRoot}>
        <div className={styles.leftbg}>
          <img src={loginBg3} />
        </div>
        <div className={`${styles.loginRightSide} ${styles.loginComps}`}>
          <div className={styles.loginRightTop}>
            <div className={styles.currentForm}>
              {routePath === "step1" ? (
                loginType === "QRCODE" ? (
                  <Popover
                    placement="left"
                    overlayClassName="qrTooltip"
                    title="账号登录"
                    align={{ offset: [10, 0] }}
                  >
                    <img
                      className={`${styles["qrcode-img"]} ${styles.qrImgHover}`}
                      onClick={() => {
                        setLoginType("MOBILE");
                      }}
                      src={mobileImg}
                    />
                  </Popover>
                ) : (
                  <Popover
                    placement="left"
                    overlayClassName="qrTooltip"
                    title="二维码登录"
                    align={{ offset: [10, 0] }}
                  >
                    <img
                      className={`${styles["qrcode-img"]} ${styles.mobileImgHover}`}
                      onClick={() => {
                        setLoginType("QRCODE");
                      }}
                      src={qrcodeImg}
                    />
                  </Popover>
                )
              ) : (
                ""
              )}
              {currentForm}
            </div>
          </div>
          {/* {routePath === "step2" && loginType === "MOBILE" ? (
          <p className="updatePhoneTip">手机号停用？请找单位同事代为申请修改登录手机号</p>
        ) : null}
        {routePath !== "active" && TELSERVICE && <p className="kufu">客服电话：{TELSERVICE}</p>} */}
        </div>

        <BindMobileModal
          visible={bindMobileVisible}
          loginName={loginName}
          loginType={loginType}
          teamId={teamId}
          onSuccess={() => {
            onSelectTeam(teamId, userData);
          }}
          closable={(accountInfo || {}).hasIdNum}
          onClose={() => {
            setBindMobileVisible(false);
            onSelectTeam(teamId, userData);
          }}
        />
        {/* <NDAModal
          visible={ndaModalVisible}
          onSuccess={() => {
            // cookies.set('nda_readed', 'true');
            localStorage.setItem("nda_readed", "true");
            setNDAModalVisible(false);
          }}
          onClose={() => {
            setNDAModalVisible(false);
            focusSDK.appExit?.();
          }}
        /> */}
      </div>
    </LoginFormContext.Provider>
  );
}

export default LoginComp;
